export const participants = {
    GET_INFO_ABOUT_PARTICIPANT : "GET_INFO_ABOUT_PARTICIPANT",
    GET_INFO_ABOUT_PARTICIPANT_SUCCESS : "GET_INFO_ABOUT_PARTICIPANT_SUCCESS",
    CLEAR_ABOUT_PARTICIPANT_INFO : "CLEAR_ABOUT_PARTICIPANT_INFO",
}